import MessagePageView from "./MessagePageView";

function MessagePage() {
  return <MessagePageView />;
}

export default MessagePage;
